import React, { Children, isValidElement, cloneElement } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";

import {
  SIGNIN_PATH,
  ADMIN_HOME_PATH,
  RECEPTIONIST_HOME_PATH,
} from "../../constants/paths";

const UserIsAuthRoute = ({ children, ...rest }) => {
  const auth = useSelector((state) => state.firebase.auth);
  const profile = useSelector(({ firebase }) => firebase.profile);

  return (
    <Route
      {...rest}
      render={({ location, history, match }) => {
        const childrenWithProps = Children.map(children, (child) => {
          // Checking isValidElement is the safe way and avoids a TS error too.
          if (isValidElement(child)) {
            return cloneElement(child, { location, history, match });
          }

          return child;
        });

        if (
          isLoaded(auth) &&
          !isEmpty(auth) &&
          isLoaded(profile) &&
          !isEmpty(profile) &&
          !profile.isAdmin &&
          !profile.isReceptionist
        ) {
          return childrenWithProps;
        }

        if (
          isLoaded(auth) &&
          !isEmpty(auth) &&
          isLoaded(profile) &&
          !isEmpty(profile) &&
          profile.isAdmin &&
          !profile.isReceptionist
        ) {
          return (
            <Redirect
              to={{
                pathname: ADMIN_HOME_PATH,
                state: { from: location },
              }}
            />
          );
        }

        if (
          isLoaded(auth) &&
          !isEmpty(auth) &&
          isLoaded(profile) &&
          !isEmpty(profile) &&
          !profile.isAdmin &&
          profile.isReceptionist
        ) {
          return (
            <Redirect
              to={{
                pathname: RECEPTIONIST_HOME_PATH,
                state: { from: location },
              }}
            />
          );
        }

        return (
          <Redirect
            to={{
              pathname: SIGNIN_PATH,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default UserIsAuthRoute;
